module.exports = __webpack_public_path__ + "img/04_no.1c785346.svg";